import script from "./UserCreateDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./UserCreateDialog.vue?vue&type=script&setup=true&lang=js"

import "./UserCreateDialog.vue?vue&type=style&index=0&id=304f255e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-304f255e"]])

export default __exports__